import EnrollmentStatusEnum from '@/enums/enrollmentStatus'

export default class Util {
  static getAllEnrollmentStatus () {
    return EnrollmentStatusEnum()
  }

  static getEnrollmentStatusString (status) {
    const string = EnrollmentStatusEnum().find(obj => obj.value === status)
    if (string) {
      return string.text
    }

    return ''
  }
}
